
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const List = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <rect x="9.3" y="5.7" width="11.3" height="1.5"></rect>
            <rect x="9.3" y="11.8" width="11.3" height="1.5"></rect>
            <rect x="9.3" y="17.8" width="11.3" height="1.5"></rect>
          </g>
          <circle cx="5.6" cy="6.5" r="1.3"></circle>
          <circle cx="5.6" cy="12.5" r="1.3"></circle>
          <circle cx="5.6" cy="18.5" r="1.3"></circle>
        </g>
      </g>
    </IconBase>);
};

List.defaultProps = {
  title: 'List',
};

export default List;
